import React, { useContext, useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import moment from "moment";
import { GetProductionAtomData, GetProductionEdit, ResetProductionEdit } from "../../store/productionAtom";
import { productionService } from "../../services/productionService";
import { isArray } from "lodash";
import { create } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";
import LogicContext from "../../Context/LogicContext";
import { useNavigate } from "react-router-dom";



const NewProductionPage = () => {
      const getProductionAtomData = GetProductionAtomData();
      const [itemList, setItemList] = useState([]);
      const [productionQuantity, setProductionQuantity] = useState(1);
        const myPromiseModal = create(GeneralModal);
         const logicContext = useContext(LogicContext);
          const navigate = useNavigate();
          const getProductionEdit = GetProductionEdit();
          const resetProductionEdit = ResetProductionEdit();
 
  const { register, handleSubmit,   formState: { errors } , reset , getValues, setValue, control } = useForm({
    defaultValues: {
      production_item_id: "",
      production_date:  moment(new Date(), "DD-MM-YYYY").format("YYYY-MM-DD"),
      warehouse_id: "",
      production_quantity: 1,
      remark: "Initial remark",
    },
  });

  useEffect(()=> {
    if(getProductionEdit?.ref_no && getProductionEdit?.itemList?.length){
      setValue("ref_no", getProductionEdit?.ref_no);
      setValue("production_item_id", getProductionEdit?.production_item_id);
      setValue("production_date",  moment(getProductionEdit?.production_date).format("YYYY-MM-DD"));
      setValue("warehouse_id",getProductionEdit?.warehouse_id );
      setValue("production_quantity",getProductionEdit?.production_quantity );
      setValue("remark",getProductionEdit?.remark );
      setProductionQuantity(getProductionEdit?.production_quantity );
      setItemList(getProductionEdit?.itemList);

    }
    return ()=> {
      resetProductionEdit();
    }

  },[getProductionEdit?.ref_no]);




  const onSubmit = async (data) => {
    const formData = getValues();
    const updateMsg = `Production with id #${getProductionEdit?.ref_no} will be updated!`;
    const newMsg = `Do you want to save this record`;
 
   const result = await myPromiseModal({ title: "Confirmation",  body: getProductionEdit?.ref_no ? updateMsg: newMsg,
      showInput: false,  placeHolder: "", });
      if(result?.decision === false){
        return ;// User choose not to submit the form
      }
    let option = getProductionEdit?.ref_no ? 2: 1;
    var tempStringList = itemList?.map((item) => {
      let temp = `<a> <item_id>${item.item_id}  </item_id>
          <req_quantity_per_unit>${item?.required_quantity} </req_quantity_per_unit>
          <item_quantity>${item?.required_quantity} </item_quantity>
          <extra_quantity>${item?.extra_quantity} </extra_quantity>
            </a>`;
      return temp;
    });

    const finalForm = {production_date:formData?.production_date, warehouse_id:formData?.warehouse_id,
      production_item_id:formData?.production_item_id, production_quantity:productionQuantity,
      remark:formData?.remark, "xml_string": `<root> ${tempStringList} </root>`,option:option
    }
    if(getProductionEdit?.ref_no){
      finalForm["ref_no"] = getProductionEdit?.ref_no;
    }

    productionService.submitProduction(finalForm).then((response)=> {
      const cleanResponse =  logicContext.httpResponseManager(response.data?.[0] || response.data?.result_status?.[0]);
      logicContext.showToast(cleanResponse?.message_text, 'success');
      sessionStorage.setItem('reloadPage', 'true');
      resetProductionEdit();
      navigate(-1);
    }).catch((err)=> {
    })

  
  };


  const onFinishGoodsSelect = (select) => {
    const itemId = select?.target?.value;
    setProductionQuantity(1);
    productionService.productionFinishedItem(itemId).then((res)=> {
        if(isArray(res?.data?.required_item_info) && res?.data?.required_item_info?.length ){
          setItemList(res?.data?.required_item_info);
        }
    });
  }


  const handleExtraQuantityChange = (index, newValue) => {
    setItemList((prevList) => {
      const updated = [...prevList];
      updated[index] = {
        ...updated[index],
        extra_quantity: Number(newValue), // cast to number if needed
      };
      return updated;
    });
  };


  const handleProductionQtyChange = (newValue) => {
    const quantity = Number(newValue);
    setProductionQuantity(quantity);
  
    setItemList(prevList =>
      prevList.map(item => ({
        ...item,  required_quantity:  Number(item.setup_quantity_per_unit) * quantity,
      }))
    );
  };




  return (
    <div className="p-6 max-w-full mt-4 mx-auto bg-white shadow rounded-xl">
        <h4 className="m-2 font-bold text-center" >  {getProductionEdit?.ref_no ? " Update Production": " New Production"} </h4>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-6">
          <h2 className="text-xl font-bold">Ref. No #  {getProductionEdit?.ref_no} </h2>
        </div>

        {/* Top form fields */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div>
            <label className=" mb-1 text-gray-700">Finish Goods</label>
            <select
              {...register("production_item_id",  { required: "finishGoods is required"  })} 
            onChange={onFinishGoodsSelect}
              placeholder="select finished goods"
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            >
          
              {getProductionAtomData?.production_setup_info?.map((item, idx)=> {
                return (

                    <option key={idx} value={item?.Production_Item_Id}>{item?.Production_Item_Name} </option>
                )
              })}
            </select>
            <small className="text-danger">
                {errors?.production_item_id && errors.production_item_id.message}
              </small>
          </div>

          <div>
            <label className=" mb-1 text-gray-700">Date</label>
            <input
              type="production_date"
              {...register("production_date")}
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            />
          </div>

          <div>
            <label className=" mb-1 text-gray-700">Warehouse</label>
            <select
              {...register("warehouse_id",  { required: "Warehouse is required"  })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            >
            {getProductionAtomData?.warehouse_info?.map((warehouse, idx)=> {
                return (
                    <>
                        <option key={idx} value={warehouse?.Warehouse_Id} >{warehouse?.Warehouse_Name} </option>
                    </>
                )
            })}
            </select>
            <small className="text-danger">
                {errors?.warehouse_id && errors.warehouse_id.message}
              </small>
          </div>
        </div>

        {/* Item Quantity Remark */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className=" mb-1 text-gray-700">Item Quantity</label>
            <input
              type="text"
              min={1}
             
              value={productionQuantity}
              onChange={(e) => handleProductionQtyChange( e.target.value)}
              placeholder="Enter item quantity"
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            />
          </div>
          <div>
            <label className=" mb-1 text-gray-700">Remark</label>
            <input
              type="text"
              {...register("remark")}
              placeholder="Enter remark"
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            />
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto mb-6">
          <table className="w-full table-auto border-collapse border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-200 px-4 py-2 text-left">ID</th>
                <th className="border border-gray-200 px-4 py-2 text-left">Name</th>
                <th className="border border-gray-200 px-4 py-2 text-left">SKU</th>
                <th className="border border-gray-200 px-4 py-2 text-left">Category</th>
                <th className="border border-gray-200 px-4 py-2 text-left">Qty/Unit</th>
                <th className="border border-gray-200 px-4 py-2 text-left">Req. Qty</th>
                <th className="border border-gray-200 px-4 py-2 text-left">Extra Qty</th>
              </tr>
            </thead>
            <tbody>
              {itemList.map((item, idx) => (
                <tr key={idx} className="text-gray-700">
                  <td className="border border-gray-200 px-4 py-2">{item.item_id}</td>
                  <td className="border border-gray-200 px-4 py-2 font-semibold">{item.item_name}</td>
                  <td className="border border-gray-200 px-4 py-2">{item.item_sku}</td>
                  <td className="border border-gray-200 px-4 py-2">{item.item_category_name}</td>
                  <td className="border border-gray-200 px-4 py-2">{item.setup_quantity_per_unit}</td>
                  <td className="border border-gray-200 px-4 py-2 text-blue-600">{item.required_quantity}</td>
                  <td className="border border-gray-200 px-4 py-2 text-red-600">
                  <input
                    type="number"
                    min={0}
                    value={item.extra_quantity ?? 0}
                    onChange={(e) => handleExtraQuantityChange(idx, e.target.value)}
                    className="w-80 border border-gray-300 rounded px-2 py-1"
                  />
                </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Buttons */}
        <div className="flex justify-end space-x-4">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          {/* <button
            type="button"
            className="bg-gray-100 text-blue-600 px-6 py-2 rounded-lg shadow hover:bg-gray-200"
          >
            Delete
          </button> */}
          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-700"
          >
            {getProductionEdit?.ref_no ? "Update": "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewProductionPage;
